<template>
  <div class="modal">
    <div class="modal-content">
      <h3>Name Chat</h3>
      <text-input
        label="Chat Name"
        :model="newGroupName"
        v-model="newGroupName"
        required
        focused
        :maxLength="30"
        class="group__name"
      />
      <div class="modal_buttons">
        <pge-button
          label="Cancel"
          template="text"
          @click="cancel"
          :disabled="buttonDisabled"
        />
        <pge-button
          label="Save"
          template="filled"
          @click="confirm"
          :disabled="!newGroupName || buttonDisabled || newGroupName?.trim().length == 0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from '../inputs/TextInput.vue';
import PgeButton from '../PgeButton.vue';

export default {
  components: {
    TextInput,
    PgeButton,
  },
  props: {
    currentGroupName: String,
  },
  data() {
    return {
      newGroupName: this.currentGroupName,
      buttonDisabled: false,
    };
  },
  methods: {
    confirm() {
      if (this.newGroupName.trim().length > 0) {
        this.buttonDisabled = true;
        this.$emit("confirm", this.newGroupName.trim());
      } else {
        this.buttonDisabled = true;
      }
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-content {
  background-color: #fff;
  border-radius: 12px;
  padding: 24px;
  max-width: 328px;
  width: 100%;

  h3 {
    color: #000;
    font-family: Lato, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    letter-spacing: -0.396px;
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    margin-top: 0;
  }

  .group__name {
    margin-bottom: 24px;
  }

  label {
    color: #000;
    font-family: Lato, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: block;
    margin-bottom: 13px;
  }

  input {
    display: block;
    width: 100%;
    border-radius: 5px;
    background: #EFEFEF;
    height: 40px;
    padding: 0 15px;
    margin-bottom: 16px;
    border: none;
    outline: none;
  }

  .modal_buttons {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    column-gap: 8px;
  }
}
</style>
